// 解决IE浏览器ES6的问题
// import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

import Vue from 'vue'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import ElementUI from 'element-ui'
import '@/styles/element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css';
import 'vue2-org-tree/dist/style.css'
// import 'element-ui/lib/theme-chalk/index.css'

// import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import '@/styles/index.scss' // global css
import '@/styles/iconfont.scss'

import App from './App.vue'
import router from './router'
import store from './store'

import '@/icons' // icon
// import '@/assets/iconfont/iconfont.css' // 样式文件
import './permission' // permission control
import '@/directives/permission'

Vue.use(ElementUI, { size: 'small' })
import DoneMessage from './utils/resetMessage'
// 命名根据需要，DonMessage只是在文章中使用
Vue.prototype.$message = new DoneMessage()
Vue.config.productionTip = false

Vue.use(require('vue-cookies'))

import ECharts from 'vue-echarts'
Vue.component('v-chart', ECharts)
Vue.prototype.$echarts = ECharts

// 修改title
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

import Model from '@/plugins/Model'
Vue.use(Model)

import confirm from '@/plugins/Confirm'
Vue.use(confirm)

// 务必在加载 Vue 之后，立即同步设置以下内容
if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true
}

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
